import React, { useState } from 'react';
import { Star, MessageSquare, Search, CheckCircle, Mail, FolderKanban } from 'lucide-react';
import { Button } from './ui/Button';
export const InfluencerHub = () => <section className="py-16 bg-white border-t border-gray-100" data-id="element-428">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-429">
      <div className="inline-flex items-center justify-center mb-6" data-id="element-430">
        <img src="https://cdn.magicpatterns.com/uploads/2roKm1Fk7NMWKUUjaFCrht/im_(2).png" alt="Top Influencer Marketplaces 2026 Badge" className="h-32 w-auto" data-id="element-431" />
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-432">
        Ranked #7 Best Influencer Marketing Marketplace
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-433">
        Recognized by{' '}
        <a href="https://influencermarketinghub.com/influencer-marketplaces/" target="_blank" rel="noopener noreferrer" className="text-zano-pink hover:underline font-medium" data-id="element-434">
          Influencer Marketing Hub
        </a>{' '}
        for our unique approach to capture represented talent at scale —
        something no one else is doing.
      </p>
      <p className="text-sm text-gray-500 max-w-xl mx-auto" data-id="element-435">
        Zano was placed #7 because of our unique position in the market:
        providing direct access to the elite layer of talent representation and
        connecting brands with 400+ agencies managing 6,000+ creators.
      </p>
    </div>
  </section>;
export const CapterraReviews = () => <section className="py-16 bg-gray-50 border-t border-gray-100" data-id="element-436">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-437">
      <div className="flex justify-center mb-6" data-id="element-438">
        <a href="https://www.capterra.com/p/10027632/Zano/reviews/" target="_blank" rel="noopener noreferrer" data-id="element-439">
          <img src="https://brand-assets.capterra.com/badge/fa921502-adb9-4b73-b611-d6c5e380b1b0.svg" alt="Zano reviews on Capterra" className="h-20 w-auto" data-id="element-440" />
        </a>
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-441">
        5-Star Rated on Capterra
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-442">
        Users love Zano for its ease of use and exceptional UX design.
        Navigating the platform and finding the right talent has never been
        simpler.
      </p>
    </div>
  </section>;
export const Newsletter = () => {
  const [submitted, setSubmitted] = useState(false);
  return <section className="py-20 bg-zano-charcoal text-white" data-id="element-443">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-444">
        <Mail className="mx-auto text-zano-pink mb-6" size={32} data-id="element-445" />
        <h2 className="text-3xl font-bold mb-4" data-id="element-446">Subscribe to our Newsletter</h2>
        <p className="text-gray-300 mb-8" data-id="element-447">
          Get industry insights from the agency perspective, discover top
          agencies and represented influencers on Zano, and stay updated on
          platform features and casting calls.
        </p>
        {submitted ? <div className="flex items-center justify-center gap-2 text-white font-medium" data-id="element-448">
            <CheckCircle className="text-green-400" size={20} data-id="element-449" /> Thanks — you're
            subscribed.
          </div> : <form onSubmit={e => {
        e.preventDefault();
        setSubmitted(true);
      }} className="flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto" data-id="element-450">
            <input type="email" placeholder="Enter your email" className="px-4 py-3 rounded-lg text-gray-900 w-full outline-none focus:ring-2 focus:ring-zano-pink" required data-id="element-451" />
            <Button variant="primary" className="whitespace-nowrap" type="submit" data-id="element-452">
              Subscribe
            </Button>
          </form>}
      </div>
    </section>;
};
export const ComingSoon = () => <section className="py-20 bg-white border-t border-gray-100" data-id="element-453">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-454">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-455">
        Coming Soon to Zano
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-456">
        {[{
        title: 'Live Chat',
        icon: <MessageSquare size={24} data-id="element-457" />,
        desc: 'Communicate directly with talent managers within the platform.'
      }, {
        title: 'Campaign Management',
        icon: <FolderKanban size={24} data-id="element-458" />,
        desc: 'Manage your entire campaign workflow from start to finish.'
      }, {
        title: 'AI Search & Discovery',
        icon: <Search size={24} data-id="element-459" />,
        desc: 'Find the perfect influencers instantly using advanced AI.'
      }, {
        title: 'Influencer Verification',
        icon: <CheckCircle size={24} data-id="element-460" />,
        desc: 'Agencies can request opt-in for a verified checkmark on profiles.'
      }].map((f, i) => <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 text-center" data-id="element-461">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-sm text-zano-pink mb-4" data-id="element-462">
              {f.icon}
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-463">{f.title}</h3>
            <p className="text-sm text-gray-600" data-id="element-464">{f.desc}</p>
          </div>)}
      </div>
    </div>
  </section>;